<template>
  <v-app>
    <v-navigation-drawer app clipped v-model="drawer">
      <v-list>
        <template v-for="(item, index) in items">
          <v-list-group
            v-if="item.visible"
            :key="index"
            v-model="item.active"
            :prepend-icon="item.icon"
            no-action
            color="var(--app-dark-blue-1)"
          >
            <template v-if="item.childs" v-slot:activator>
              <v-list-item-content>
                <v-list-item-title
                  style="white-space: pre-line; line-height: 1.5"
                >
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="child in checkAccesses(item.childs, item)"
              :key="child.title"
              :to="child.link"
              @click="deleteLocal"
            >
              <v-list-item-content v-if="item.childs">
                <div class="list-item-child">
                  <div style="line-height: 1.5">
                    {{ child.title }}
                  </div>
                  <div class="list-item-child-circle" v-if="child.value">
                    {{ child.value }}
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
        <div v-for="(item, index) in itemsSolo" :key="index + 1000">
          <v-list-item
            color="var(--app-dark-blue-1)"
            @click="deleteLocal(), closeOther()"
            :to="item.link"
            v-if="item.visible"
          >
            <div class="d-flex">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-title
                style="white-space: pre-line; line-height: 1.5"
                >{{ item.title }}</v-list-item-title
              >
            </div>
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left style="z-index: 5">
      <v-icon
        color="white"
        style="margin-right: 30px"
        @click.stop="drawer = !drawer"
        >mdi-dots-vertical</v-icon
      >

      <v-toolbar-title>
        <img
          style="width: 230px; margin-top: 10px"
          src="../../src/assets/logo.png"
        />
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-icon color="white" @click="logoutBtn">mdi-logout-variant</v-icon>
    </v-app-bar>

    <v-main v-if="this.$route.path === '/'">
      <div class="empty-container">
        <div class="empty-container-title" v-if="$cookies.get('VTBUserName')">
          Добро пожаловать, {{ $cookies.get("VTBUserName") }}
        </div>
        <div v-else class="empty-container-title">Добро пожаловать</div>
        <img class="empty-container-img" src="../../src/assets/logoLogin.png" />
        <div class="empty-container-text">
          Выберите нужный пункт меню, для начала работы
        </div>
      </div>
    </v-main>
    <v-main v-else>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => ({
    drawer: null,

    itemsSolo: [
      {
        title: "Пункты меню",
        isUrl: false,
        icon: "mdi-format-list-bulleted",
        active: false,
        link: { name: "AppSections" },
        menuKey: "menu_items",
        visible: false,
      },
      {
        title: "События",
        isUrl: false,
        icon: "mdi-calendar",
        active: false,
        link: { name: "Events" },
        menuKey: "events",
        visible: false,
      },

      {
        title: "Пользователи",
        isUrl: false,
        icon: "mdi-account-group",
        active: false,
        link: { name: "Users" },
        menuKey: "mobile_users",
        visible: false,
      },
      // {
      //     title: 'Push',
      //     isUrl: false,
      //     icon: 'mdi-cellphone-text',
      //     active: false,
      //     link: {name: 'Push'},
      //      roles: ['admin']
      // },

      {
        title: "",
        isUrl: false,
        icon: "mdi-view-dashboard",
        active: false,
        link: { name: "Constructor" },
        menuKey: "pages",
        visible: false,
      },
      {
        title: "Обращения",
        isUrl: false,
        icon: "mdi-message-processing",
        active: false,
        link: { name: "Appeal" },
        menuKey: "appeals",
        visible: false,
      },
      {
        title: "Информационные бюллетени",
        isUrl: false,
        icon: "mdi-folder-information",
        active: false,
        link: { name: "Bulletins" },
        menuKey: "bulletin",
        visible: false,
      },
      {
        title: "Опросы",
        isUrl: false,
        icon: "mdi-order-bool-descending",
        active: false,
        link: { name: "Polls" },
        menuKey: "polls",
        visible: false,
      },
      {
        title: "Трансляция голосований",
        isUrl: false,
        icon: "mdi-broadcast",
        active: false,
        link: { name: "VotingBroadcast" },
        menuKey: "events",
        visible: false,
      },
      {
        title: "Дивиденды",
        isUrl: false,
        icon: "mdi-cash",
        active: false,
        link: { name: "Dividends" },
        menuKey: "ksa",
        visible: false,
      },
      {
        title: "Привилегии",
        isUrl: false,
        icon: "mdi-file-check",
        active: false,
        link: { name: "Privileges" },
        menuKey: "ksa",
        visible: false,
      },
      {
        title: "Обучение",
        isUrl: false,
        icon: "mdi-book-open-variant",
        active: false,
        link: { name: "Trainings" },
        menuKey: "ksa",
        visible: false,
      },
      {
        title: "Истории",
        isUrl: false,
        icon: "mdi-book-open-page-variant",
        active: false,
        link: { name: "Stories" },
        menuKey: "stories",
        visible: false,
      },
    ],
    items: [
      {
        title: "Главный экран",
        isUrl: false,
        icon: "mdi-home",
        active: false,
        menuKey: "main_page",
        visible: false,
        childs: [
          {
            title: "Баннеры",
            link: { name: "Banners" },
            menuKeys: ["watch", "edit"],
          },
          {
            title: "Котировки",
            link: { name: "Quotes" },
            menuKeys: ["watch", "edit"],
          },
        ],
      },
      {
        title: "Новости",
        isUrl: false,
        icon: "mdi-newspaper-variant",
        active: false,
        menuKey: "news",
        visible: false,
        childs: [
          {
            title: "Список новостей",
            link: { name: "News" },
            menuKeys: ["watch", "edit"],
          },
          {
            title: "Категории",
            link: { name: "Categories" },
            menuKeys: ["watch", "edit"],
          },
        ],
      },
      {
        title: "КСА",
        isUrl: false,
        icon: "mdi-account-multiple",
        active: false,
        menuKey: "ksa",
        visible: false,
        childs: [
          {
            title: "Состав КСА",
            link: { name: "Shareholders" },
            menuKeys: ["watch", "edit"],
          },
          {
            title: "Деятельность совета",
            link: { name: "CouncilActivity" },
            menuKeys: ["watch", "edit"],
          },
        ],
      },
      {
        title: "Выборы КСА",
        isUrl: false,
        icon: "mdi-account-multiple",
        active: false,
        menuKey: "ksaElection",
        visible: false,
        childs: [
          {
            title: "Кандидаты",
            link: { name: "Candidates" },
            menuKeys: ["watch", "edit"],
          },
          {
            title: "Блоки выбора КСА",
            link: { name: "SelectionBlocks" },
            menuKeys: ["watch", "edit"],
          },
        ],
      },
      {
        title: "Конференции",
        isUrl: false,
        icon: "mdi-message-question",
        active: false,
        menuKey: "ksa",
        visible: false,
        childs: [
          {
            title: "Актуальная Конференция",
            link: { name: "ConferenceActual" },
            menuKeys: ["watch", "edit"],
          },
          {
            title: "Архив",
            link: { name: "ConferenceArchive" },
            menuKeys: ["watch", "edit"],
          },
          {
            title: "Реакции",
            link: { name: "Reactions" },
            menuKeys: ["watch", "edit"],
          },
        ],
      },
      {
        title: "Оповещения",
        isUrl: false,
        icon: "mdi-email",
        active: false,
        menuKey: "notifications",
        visible: false,
        childs: [
          {
            title: "Рассылка",
            link: { name: "LettersEvents" },
            menuKeys: ["watch", "edit"],
          },
          {
            title: "Push",
            link: { name: "Push" },
            menuKeys: ["watch", "edit"],
          },
          {
            title: "СМС",
            link: { name: "SMS" },
            menuKeys: ["watch", "edit"],
          },
          {
            title: "Письма",
            link: { name: "Mail" },
            menuKeys: ["watch", "edit"],
          },
        ],
      },
      {
        title: "Настройки",
        isUrl: false,
        icon: "mdi-cog",
        active: false,
        menuKey: "settings",
        visible: false,
        childs: [
          {
            title: "Интеграция",
            link: { name: "Setting" },
            menuKeys: ["watch", "edit"],
          },
          {
            title: "Регионы",
            link: { name: "Regions" },
            menuKeys: ["watch", "edit"],
          },
          {
            title: "Темы вопросов",
            link: { name: "TopicsQuestions" },
            menuKeys: ["watch", "edit"],
          },
          {
            title: "Система",
            link: { name: "System" },
            menuKeys: ["watch", "edit"],
          },
        ],
      },
      {
        title: "Клуб акционеров",
        isUrl: false,
        icon: "mdi-chat",
        active: false,
        menuKey: "shareholders_club",
        visible: false,
        childs: [
          {
            title: "Список чатов",
            link: { name: "ChatList" },
            menuKeys: ["watch", "edit"],
            // value: '1',
          },
          {
            title: "Список пользователей",
            link: { name: "ChatUsers" },
            menuKeys: ["watch", "edit"],
            // value: '9+',
          },
          {
            title: "Настройки",
            link: { name: "ChatSettings" },
            menuKeys: ["edit"],
          },
        ],
      },
      {
        title: "Пользователи системы",
        isUrl: false,
        icon: "mdi-account-network",
        active: false,
        menuKey: "system_users",
        visible: false,
        childs: [
          {
            title: "Пользователи",
            link: { name: "SystemUsers" },
            menuKeys: ["watch", "edit"],
          },
          {
            title: "Роли",
            link: { name: "SystemRoles" },
            menuKeys: ["watch", "edit"],
          },
        ],
      },
      {
        title: "Мероприятия",
        isUrl: false,
        icon: "mdi-seat",
        active: false,
        menuKey: "ksa",
        visible: false,
        childs: [
          {
            title: "Актуальное",
            link: { name: "ActivityActual" },
            menuKeys: ["watch", "edit"],
          },
          {
            title: "Список",
            link: { name: "Activities" },
            menuKeys: ["watch", "edit"],
          },
          {
            title: "Контент монитора",
            link: { name: "ActivityMonitorContent" },
            menuKeys: ["watch", "edit"],
          },
        ],
      },
      // {
      //   title: "Quorum",
      //   isUrl: false,
      //   icon: "mdi-microphone",
      //   active: false,
      //   menuKey: "quorum",
      //   visible: false,
      //   childs: [
      //     {
      //       title: "Пользователи",
      //       link: { name: "QuorumUsers" },
      //       menuKeys: ["watch", "edit"],
      //     },
      //     {
      //       title: "Push",
      //       link: { name: "QuorumPush" },
      //       menuKeys: ["watch", "edit"],
      //     },
      //   ],
      // },
    ],
  }),
  created() {
    // this.itemsChildrenRole()

    this.checkRoute();
    this.checkRole();
  },
  methods: {
    closeOther() {
      this.items.forEach((x) => {
        x.active = false;
      });
    },
    checkAccesses(items, item) {
      if (items.length > 0) {
        const neededObj = this.$store.getters.user.sections.filter(
          (i) => i.key == item.menuKey
        );
        const keysAccesses = neededObj[0].accesses
          .map((i) => {
            if (i.value) {
              return i.key;
            }
          })
          .filter((i) => i);
        let newArr = [];
        items.forEach((element) => {
          element.menuKeys.forEach((el) => {
            if (keysAccesses.find((i) => i == el)) {
              const copyLink = newArr.filter(
                (i) => i.link.name == element.link.name
              );
              if (!copyLink[0]) {
                newArr.push(element);
              }
            }
          });
        });
        return newArr;
      }
    },
    checkRole() {
      for (
        let index = 0;
        index < this.$store.getters.user.sections.length;
        index++
      ) {
        const element = this.$store.getters.user.sections[index];
        for (let i = 0; i < this.items.length; i++) {
          const el = this.items[i];
          if (element.key == el.menuKey) {
            let boolean = false;
            element.accesses.forEach((element) => {
              if (element.value) {
                boolean = true;
              }
            });
            el.visible = boolean;
          }
        }

        for (let ind = 0; ind < this.itemsSolo.length; ind++) {
          const elem = this.itemsSolo[ind];
          if (element.key == elem.menuKey) {
            let boolean = false;
            element.accesses.forEach((element) => {
              if (element.value) {
                boolean = true;
              }
            });
            elem.visible = boolean;
          }
          if (elem.menuKey == "pages") {
            elem.title = this.roleEditUser("pages")
              ? "Страницы"
              : "Аналитика и отчетность";
          }
        }
      }
      this.items = this.items.sort((a, b) => {
        if (a.title < b.title) {
          return -1;
        } else if (a.title > b.title) {
          return 1;
        }
        return 0;
      });
      this.itemsSolo = this.itemsSolo.sort((a, b) => {
        if (a.title < b.title) {
          return -1;
        } else if (a.title > b.title) {
          return 1;
        }
        return 0;
      });
      const moveAfter = (name, afterName) => {
        const index = this.itemsSolo.findIndex((item) => item.link.name == name);
        const afterIndex = this.itemsSolo.findIndex(
          (item) => item.link.name == afterName
        );
        if (index < 0 || afterIndex < 0) return;
        const [item] = this.itemsSolo.splice(index, 1);
        this.itemsSolo.splice(afterIndex + (index < afterIndex ? 0 : 1), 0, item);
      };
      moveAfter("VotingBroadcast", "Events");
      moveAfter("Constructor", "VotingBroadcast");
    },

    deleteLocal() {
      localStorage.removeItem("newsOptionTable");
      localStorage.removeItem("pushOptionTable");
      localStorage.removeItem("eventsOptionTable");
      localStorage.removeItem("pagesOptionTable");
      localStorage.removeItem("chatsTab");
    },
    checkRoute() {
      for (let index = 0; index < this.items.length; index++) {
        const element = this.items[index];
        for (let index = 0; index < element.childs.length; index++) {
          const el = element.childs[index];
          if (this.$route.name == el.link.name) {
            element.active = true;
          }
        }
      }
    },

    logoutBtn() {
      this.$cookies.remove(this.$store.state.adminPanelKeyCookie);
      if (this.$cookies.get("VTBUserName")) {
        this.$cookies.remove("VTBUserName");
      }

      this.$axios
        .get(this.$store.getters.apiAdminPanelV1 + "/logout", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
        })
        .then(() => {
          this.$router.go(0);
        })
        .catch(() => {
          this.$router.go(0);
        });
    },
  },
};
</script>
<style lang="scss">
.v-app-bar--fixed {
  background: var(--app-dark-blue-1) !important;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 14px !important;
}

.v-application--is-ltr
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 50px !important;
}

.v-list {
  margin-top: 20px;
}

.list-item-child {
  display: flex;
  justify-content: space-between;

  .list-item-child-circle {
    width: 20px;
    min-width: 20px;
    height: 20px;
    min-height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--app-dark-blue-1);
    color: #ffffff;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 600;
  }
}

.empty-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;

  .empty-container-title {
    color: var(--app-dark-blue-1);
    font-size: 34px;
    font-weight: 600;
    margin-bottom: 56px;
  }

  .empty-container-img {
    width: 315px;
  }

  .empty-container-text {
    color: var(--app-dark-blue-1);
    font-size: 20px;
    font-weight: 400;
    margin-top: 24px;
  }
}
</style>
